import H9KQUANT_EXT_1 from "./H9KQUANT_EXT_1";

export default {
  H9KQUANT_EXT_1,
};
